// extracted by mini-css-extract-plugin
export default {"rangeTab":"DetailsToolbar_rangeTab__fMrO7","rangeTabItem":"DetailsToolbar_rangeTabItem__3Kpir","rangeTabActive":"DetailsToolbar_rangeTabActive__QPOzD"};